import { BarChartOutlined, CalendarOutlined, PushpinOutlined } from '@ant-design/icons';
import { Collapse, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Await, defer, useFetcher, useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { confirmDelivery, confirmDeliveryByOnlyVendor, getArtwork, getComments, getDeliveryDetails, getOrderDocuments, getProductionDetails, getSample, sendArtWork, sendComment, sendDispatchDate, sendDispatchDateByOnlyVendor, sendOrderShippingDetailsByFile, sendShippingDetails, sendShippingDetailsByVendor, sendTemplate } from '../../api/vendor/vendorProduction';
import { ProductionStep } from '../../components/Steps';
import { AuditTrails, ItemDetailsSection } from '../../components/data';
// import styles from '../../components/data/quotation/quotation-item.module.scss';
import { uploadFileFromObject } from '../../api/common/index.js';
import { CommunicationPanel } from '../../components/communication/communication-panel.jsx';
import { OrderDocumentsNew } from '../../components/data/production/orderDocuments.jsx';
import { Box } from '../../components/design';
import { Page } from '../../components/page';
import { ValidationError } from '../../library/classes/exceptions/index.js';
import { SuppliersSteps } from '../../library/constants/finisher-step.js';
import { ProductionSteps } from '../../library/constants/production-steps.js';
import { generateRouteUrl } from '../../library/constants/routes.js';
import { VendorRole } from '../../library/constants/supplier.js';
import { convertDataTypes } from '../../library/helpers/index.js';
import { convertToNested, formatDate } from '../../library/utils';
import style from './production-details.module.scss';
const { Panel } = Collapse;

const getStepCompoment = (status) => ProductionSteps.find(s => s.status === status)?.component()
const getVendorStepCompoment = (status) => SuppliersSteps.find(s => s.status === status)?.component()


const ProductionDetails = () => {
	const { productionDetails, supplier_flow, auditTrail, documents, communicationHistory } = useLoaderData();
	const [current, setCurrent] = useState(productionDetails.vendor_status);
	const [vendorCurrent, setVendorCurrent] = useState(productionDetails?.vendor_delivery_status)
	const navigate = useNavigate()
	const communicationFecher = useFetcher()
	const { id } = useParams()
	useEffect(() => {
		setCurrent(productionDetails.vendor_status)
		setVendorCurrent(productionDetails.vendor_delivery_status)
	}, [productionDetails.vendor_status, productionDetails?.vendor_delivery_status])
	const CurrentComponent = getStepCompoment(current)
	const VendorCurrentComponent = getVendorStepCompoment(vendorCurrent)

	return (
		<Page title={"Production Details"} canGoBack={true}>
			<div className={style.gap}>
				<div className={style.grid}>
					<Collapse defaultActiveKey={['1']} expandIconPosition="end">
						<Panel header={productionDetails.product.name} key="1">
							<ItemDetailsSection detail={productionDetails} />
						</Panel>
					</Collapse>
					<Collapse defaultActiveKey={['1']} expandIconPosition="end">
						<Panel header={<><img src="/icons/iteminformation.svg" style={{ width: '1rem', verticalAlign: 'sub', marginRight: '8px' }} />Item Information</>} key="1" >
							<div className={`box--white ${style.projectItem}`}>
								<div className={style.itemDates}>
									<BarChartOutlined className={style.icons} />
									<div>
										Project ID <br />
										<span className={style.date}>
											{productionDetails?.global_project_id}
										</span>
									</div>
								</div>
								<div className={style.itemDates}>
									<BarChartOutlined className={style.icons} />
									<div>
										Quantity <br />
										<span className={style.date}>{
											productionDetails?.quantity
										}</span>
									</div>
								</div>
								<div className={style.itemDates}>
									<CalendarOutlined className={style.icons} />
									<div>
										Deadline Delivery Date <br />
										<span className={style.date}>
											{productionDetails.delivery_date ? formatDate(productionDetails.delivery_date) : "N/A"}
										</span>
									</div>
								</div>
								<div className={style.itemDates}>
									<PushpinOutlined className={style.icons} />
									<div>
										Delivery Location <br />
										<span className={style.date}>{<span className={style.cardValue}>{
											productionDetails.delivery_type == 3 ? 'Bulk' : productionDetails?.countries?.join(', ')
										} </span>}</span>
									</div>
								</div>
								{productionDetails?.item_delivery_address?.expected_dispatch_date && !productionDetails?.item_delivery_address?.expected_delivery_date &&
									<div className={style.itemDates}>
										<CalendarOutlined className={style.icons} />
										<div>
											Expected Dispatch Date From Vendor <br />
											<span className={style.date}>{formatDate(productionDetails.item_delivery_address.expected_dispatch_date)}</span>
										</div>
									</div>
								}
								{productionDetails?.item_delivery_address?.expected_delivery_date &&
									<div className={style.itemDates}>
										<CalendarOutlined className={style.icons} />
										<div>
											Expected Delivery Date From Vendor <br />
											<span className={style.date}>{formatDate(productionDetails.item_delivery_address.expected_delivery_date)}</span>
										</div>
									</div>
								}
							</div>
						</Panel>
					</Collapse>
				</div>
				{productionDetails.vendor_comment && <Box type={Box.BoxTypes.MEDIUM}>
					<h4>Special Comment : {productionDetails?.vendor_comment}</h4>
				</Box>}
				{productionDetails?.combi_details?.length > 1 && <Box type={Box.BoxTypes.MEDIUM}>
					<h4>Other Items Associated with this Combi Deal</h4>
					<div className={style.badgeGrid}>
						{productionDetails.combi_details && productionDetails.combi_details.map(({ item_id, quantity }) => {
							item_id != id && <div onClick={() => { navigate(generateRouteUrl('ProductionDetails', { id: item_id })) }} className={style.badge} key={item_id}>
								<p className={style.badgeTitle}>item id : {item_id}</p>
								<p className={style.badgeTitle}>Quantity : {quantity}</p>
							</div>
						}
						)}
					</div>
				</Box>}
				{supplier_flow == VendorRole.ONLY_SUPPLIER ? <Box>
					<ProductionStep
						currentStep={vendorCurrent}
						items={SuppliersSteps}
						small={true}
					/>
					<div className={style.stepBody}>
						<VendorCurrentComponent />
					</div>
				</Box> :
					<Box>
						<ProductionStep
							currentStep={current}
							items={ProductionSteps}
							small={false}
						/>
						<div className={style.stepBody}>
							<CurrentComponent />
						</div>
					</Box>

				}
				<div className={style.documentsCommunicationGrid}>
					<Collapse defaultActiveKey={['1']} expandIconPosition="end">
						<Collapse.Panel header={<><img src="/icons/documents.svg" style={{ width: '1.25rem', verticalAlign: 'sub', marginRight: '8px' }} />Documents</>} key="1">
							<React.Suspense fallback={<p>Loading Documents...</p>}>
								<Await
									resolve={documents}
									errorElement={
										<p>Error loading documents!</p>
									}
								>
									{(documents) => <OrderDocumentsNew projectId={productionDetails.project_id} itemId={productionDetails?.id} documents={documents} />}
								</Await>
							</React.Suspense>
						</Collapse.Panel>
					</Collapse>
					<Collapse defaultActiveKey={['1']} expandIconPosition="end">
						<Collapse.Panel header={<><img src="/icons/vendorcommunication.svg" style={{ width: '1.25rem', verticalAlign: 'sub', marginRight: '8px' }} />Communication</>} key="1">
							<React.Suspense fallback={<p>Loading communication...</p>}>
								<Await
									resolve={communicationHistory}
									errorElement={
										<p>Error loading communication history!</p>
									}
								>
									{(messages) => <CommunicationPanel messages={messages} onSubmit={comment => {
										communicationFecher.submit({
											action: 'sendMessage',
											comment
										}, {
											method: 'post'
										})
									}} />}
								</Await>
							</React.Suspense>
						</Collapse.Panel>
					</Collapse>
				</div>
				<Collapse defaultActiveKey={['1']} expandIconPosition="end">
					<Panel header={<><img src="/icons/audittrail.svg" style={{ width: '1.25rem', verticalAlign: 'sub', marginRight: '8px' }} />Audit Trail</>} key="1" >
						<AuditTrails logs={auditTrail} />
					</Panel>
				</Collapse>
			</div>
		</Page >
	)
}

ProductionDetails.Actions = {
	sendTemplate: async ({ data }) => {
		try {
			const { id, imageData } = data
			const { message: msg } = await sendTemplate(id, { image_ids: imageData })
			message.success(msg)
			return true
		}
		catch (error) {
			message.error(error.message)
			return false
		}
	},
	sendProof: async ({ data }) => {
		console.log(data);
		try {
			const { id, imageData } = data
			const { message: msg } = await sendArtWork(id, { image_ids: imageData })
			message.success(msg)
			return true
		}
		catch (error) {
			message.error(error.message)
			return false
		}
	},
	updateDispatchDate: async ({ params, data }) => {
		const { id } = params
		try {
			// const ship_quantity = parseInt(data.ship_quantity)
			// if (!ship_quantity) {
			// 	throw new ValidationError('Quantity is required', [
			// 		{
			// 			path: 'ship_quantity',
			// 			message: 'Quantity is required'
			// 		}
			// 	])
			// }

			const shipment_id = parseInt(data.shipment_id)
			const { message: msg } = await sendDispatchDate(id, shipment_id, {
				dispatch_date: data.dispatch_date
			})
			message.success(msg);
			return true
		}
		catch (error) {
			message.error(error.message)
			if (error instanceof ValidationError) {
				return {
					errors: error.errors
				}
			}
		}
		return false
	},

	sendDispatchInfo: async ({ params, data }) => {
		const { id } = params
		try {
			const shipmentDetails = convertToNested(data)?.map(shipment => convertDataTypes(shipment, {
				shipping_id: parseInt,
			})).filter(({ dispatch_date }) => dispatch_date.length)
			console.log({ shipmentDetails })
			const { message: msg } = await sendDispatchDate(id, { data: shipmentDetails })
			message.success(msg);
			return true
		}
		catch (error) {
			message.error(error.message)
			if (error instanceof ValidationError) {
				return {
					errors: error.errors
				}
			}
		}
		return false
	},
	sendDispatchInfoByOnlyVendor: async ({ params, data }) => {
		const { id } = params
		try {
			await sendDispatchDateByOnlyVendor(id, data)
			message.success('Details Updated Successfully');
			return true
		}
		catch (error) {
			message.error(error.message)
			if (error instanceof ValidationError) {
				return {
					errors: error.errors
				}
			}
		}
		return false
	},
	// sendDispatchInfo: async ({ params, data }) => {
	// 	const { id } = params


	// 	try {
	// 		const shipment_id = parseInt(data.shipment_id)
	// 		const { message: msg } = await sendDispatchDate(id, shipment_id, {
	// 			dispatch_date: data.dispatch_date
	// 		})
	// 		message.success(msg);
	// 		return true
	// 	}
	// 	catch (error) {
	// 		message.error(error.message)
	// 		if (error instanceof ValidationError) {
	// 			return {
	// 				errors: error.errors
	// 			}
	// 		}
	// 	}
	// 	return false
	// },
	// updateDeliveryInformation: async ({ params, data }) => {
	// 	const { id } = params
	// 	try {
	// 		const ship_quantity = parseInt(data.ship_quantity)
	// 		if (!ship_quantity) {
	// 			throw new ValidationError('Quantity is required', [
	// 				{
	// 					path: 'ship_quantity',
	// 					message: 'Quantity is required'
	// 				}
	// 			])
	// 		}

	// 		const shipment_id = parseInt(data.shipment_id)
	// 		const { message: msg } = await sendShippingDetails(id, shipment_id, {
	// 			ship_quantity,
	// 			tracking_url: data.tracking_url,
	// 			expected_date: data.expected_date,
	// 		})
	// 		message.success(msg);
	// 		return true
	// 	}
	// 	catch (error) {
	// 		message.error(error.message)
	// 		if (error instanceof ValidationError) {
	// 			return {
	// 				errors: error.errors
	// 			}
	// 		}
	// 	}
	// 	return false
	// },
	updateDeliveryInformationBulkByVendor:
		async ({ params, data }) => {
			const { id } = params
			try {
				const { shipment_id, ship_quantity, delivery_file, delivery_comment } = convertDataTypes(data, {
					shipment_id: parseInt,
					ship_quantity: parseInt
				})
				if (!ship_quantity) {
					throw new ValidationError('Quantity is required', [
						{
							path: 'ship_quantity',
							message: 'Quantity is required'
						}
					])
				}
				if (!delivery_file || !(delivery_file instanceof File)) {
					throw new ValidationError('Delivery file is required', [
						{
							path: 'delivery_file',
							message: 'Delivery file is required'
						}
					])
				}

				//Upload file
				const fileId = await uploadFileFromObject(null, delivery_file)

				const { message: msg } = await sendOrderShippingDetailsByFile(id, shipment_id, {
					ship_quantity,
					delivery_file_id: fileId,
					delivery_comment
				})
				message.success(msg);
				return true
			}
			catch (error) {
				message.error(error.message)
				if (error instanceof ValidationError) {
					return {
						errors: error.errors
					}
				}
			}
			return false
		},
	updateDeliveryInformationBulk: async ({ params, data }) => {
		const { id } = params
		try {
			const { shipment_id, ship_quantity, delivery_file, expected_date, delivery_comment } = convertDataTypes(data, {
				shipment_id: parseInt,
				ship_quantity: parseInt
			})
			if (!ship_quantity) {
				throw new ValidationError('Quantity is required', [
					{
						path: 'ship_quantity',
						message: 'Quantity is required'
					}
				])
			}
			if (!expected_date) {
				throw new ValidationError('Expected delivery date is required', [
					{
						path: 'expected_date',
						message: 'Expected delivery date is required'
					}
				])
			}
			if (!delivery_file || !(delivery_file instanceof File)) {
				throw new ValidationError('Delivery file is required', [
					{
						path: 'delivery_file',
						message: 'Delivery file is required'
					}
				])
			}

			//Upload file
			const fileId = await uploadFileFromObject(delivery_file)

			const msg = await sendOrderShippingDetailsByFile(id, shipment_id, {
				ship_quantity,
				delivery_file_id: fileId,
				expected_date,
				delivery_comment
			})
			message.success(msg);
			return true
		}
		catch (error) {
			message.error(error.message)
			if (error instanceof ValidationError) {
				return {
					errors: error.errors
				}
			}
		}
		return false
	},
	updateDeliveryInformationByVendor: async ({ params, data }) => {
		const { id } = params
		try {
			const ship_quantity = parseInt(data.ship_quantity)
			if (!ship_quantity) {
				throw new ValidationError('Quantity is required', [
					{
						path: 'ship_quantity',
						message: 'Quantity is required'
					}
				])
			}
			const tracking_url = (data.tracking_url ?? '').trim()
			const trackingUrlError = !tracking_url
				? 'Tracking URL is required'
				: !/^https?:\/\/\S+$/i.test(tracking_url)
					? 'Tracking URL must start with http:// or https://'
					: null
			if (trackingUrlError) {
				throw new ValidationError(trackingUrlError, [
					{
						path: 'tracking_url',
						message: trackingUrlError
					}
				])
			}
			const { message: msg } = await sendShippingDetailsByVendor(id, {
				ship_quantity,
				tracking_url,
				expected_delivery_date: data.expected_delivery_date,
			})
			message.success(msg);
			return true
		}
		catch (error) {
			message.error(error.message)
			if (error instanceof ValidationError) {
				return {
					errors: error.errors
				}
			}
		}
		return false
	},
	updateDeliveryInformation: async ({ params, data }) => {
		const { id } = params
		try {
			const ship_quantity = parseInt(data.ship_quantity)
			if (!ship_quantity) {
				throw new ValidationError('Quantity is required', [
					{
						path: 'ship_quantity',
						message: 'Quantity is required'
					}
				])
			}

			const shipment_id = parseInt(data.shipment_id)
			const { message: msg } = await sendShippingDetails(id, shipment_id, {
				ship_quantity,
				tracking_url: data.tracking_url,
				expected_date: data.expected_date,
			})
			message.success(msg);
			return true
		}
		catch (error) {
			message.error(error.message)
			if (error instanceof ValidationError) {
				return {
					errors: error.errors
				}
			}
		}
		return false
	},

	confirmDelivery: async ({ params, data }) => {
		const { id } = params
		try {
			const { deliveryId, image_ids, comment } = data
			const { message: msg } = await confirmDelivery(id, deliveryId, {
				image_ids,
				comment
			})
			message.success(msg);
			return true
		}
		catch (error) {
			message.error(error.message)
			if (error instanceof ValidationError) {
				return {
					errors: error.errors
				}
			}
		}
		return false
	},
	confirmDeliveryByOnlyVendor: async ({ params, data }) => {
		const { id } = params
		try {
			const { image_ids, comment } = data
			const { message: msg } = await confirmDeliveryByOnlyVendor(id, {
				image_ids,
				delivery_proof_comment: comment
			})
			message.success(msg);
			return true
		}
		catch (error) {
			message.error(error.message)
			if (error instanceof ValidationError) {
				return {
					errors: error.errors
				}
			}
		}
		return false

	},
	sendMessage: async ({ params, data }) => {
		const { id } = params
		try {
			const { comment } = data
			if (!comment || !comment.length) {
				throw new ValidationError('Please enter a message')
			}
			const msg = await sendComment(id, comment)
			message.success(msg)
			return true
		}
		catch (error) {
			message.error(error.message)
			if (error instanceof ValidationError) {
				return {
					errors: error.errors
				}
			}
			return false
		}
	},

}
ProductionDetails.Loader = async ({ params }) => {
	if (isNaN(params.id)) {
		throw new Error('Invalid Order ID')
	}
	const productionDetails = await getProductionDetails(params.id)
	if (!productionDetails) {
		throw new Error('Invalid Order')
	}

	const supplier_flow = productionDetails?.supplier_flow

	const sample = await getSample(params.id)
	if (!productionDetails) {
		throw new Error('Invalid Order')
	}
	const auditTrail = productionDetails.activity_log;
	const deliveryDetails = await getDeliveryDetails(params.id)
	const artworkData = await getArtwork(params.id)
	const documents = getOrderDocuments(params.id)
	const communicationHistory = getComments(params.id)
	return defer({
		productionDetails,
		deliveryDetails,
		artworkData,
		sample,
		supplier_flow,
		auditTrail,
		documents,
		communicationHistory
	})
}
ProductionDetails.propTypes = {
	title: PropTypes.string
}
export default ProductionDetails;
